module.exports = __webpack_public_path__ + "img/slavpotassium.bcd20610.png";